import { RECEIVE_ERRORS } from "./actions";
import {
	RECEIVE_PROFILE_DATA,
	REQUEST_PROFILE_DATA,
	REQUEST_PROFILE_DATA_UPDATE,
} from "../../profile/actions";

const initialState = [];

export function errorReducer(state = initialState, action) {
	switch (action.type) {
		case RECEIVE_ERRORS: {
			return action.data;
		}
		case RECEIVE_PROFILE_DATA:
		case REQUEST_PROFILE_DATA_UPDATE:
		case REQUEST_PROFILE_DATA: {
			return initialState;
		}
		default:
			return state;
	}
}
